import { UserPlus } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { TEAM, INFO } from "@/data/site";
import { useLang } from "@/i18n";

export const Team = () => {
  const { t } = useLang();
  return (
    <section id="team" data-testid="team-section" className="bg-secondary border-t border-border">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-24 md:py-32">
        <Reveal>
          <div className="max-w-2xl mb-14 md:mb-20">
            <span className="text-xs uppercase tracking-[0.25em] text-muted-foreground">{t("team.eyebrow")}</span>
            <h2 className="font-serif font-light text-4xl md:text-6xl tracking-tight mt-4">
              {t("team.title")}
            </h2>
            <p className="mt-5 text-foreground/60 leading-relaxed">
              {t("team.body")}
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-testid="team-grid">
          {TEAM.map((member, i) => (
            <Reveal key={member.id} delay={i * 0.08}>
              <article data-testid={`team-card-${member.id}`} className="group h-full flex flex-col bg-background border border-border overflow-hidden">
                <div className="relative aspect-[4/5] overflow-hidden bg-muted">
                  {member.photo ? (
                    <img
                      src={member.photo}
                      alt={member.name}
                      loading="lazy"
                      className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                  ) : (
                    <div className="absolute inset-0 flex items-center justify-center text-foreground/30">
                      <UserPlus strokeWidth={1} size={48} />
                    </div>
                  )}
                </div>
                <div className="p-6 md:p-7 flex-1 flex flex-col">
                  <span className="text-xs uppercase tracking-[0.2em] text-primary">{member.role}</span>
                  <h3 className="font-serif text-2xl md:text-3xl font-light mt-3">{member.name}</h3>
                  {member.bio && (
                    <p className="mt-3 text-sm text-foreground/60 leading-relaxed">{member.bio}</p>
                  )}
                </div>
              </article>
            </Reveal>
          ))}

          {/* Growth placeholder — hidden once team has 3+ members */}
          {TEAM.length < 3 && (
            <Reveal delay={TEAM.length * 0.08}>
              <a
                href={`mailto:${INFO.email}?subject=Bewerbung%20Maschas%20Atelier`}
                data-testid="team-hiring-card"
                className="group h-full flex flex-col border border-dashed border-primary/40 hover:border-primary transition-colors bg-transparent"
              >
                <div className="relative aspect-[4/5] overflow-hidden flex items-center justify-center bg-primary/5 group-hover:bg-primary/10 transition-colors">
                  <UserPlus strokeWidth={1} size={48} className="text-primary/60 group-hover:text-primary transition-colors" />
                </div>
                <div className="p-6 md:p-7 flex-1 flex flex-col">
                  <span className="text-xs uppercase tracking-[0.2em] text-primary">{t("team.hiring_eyebrow")}</span>
                  <h3 className="font-serif text-2xl md:text-3xl font-light mt-3">{t("team.hiring_title")}</h3>
                  <p className="mt-3 text-sm text-foreground/60 leading-relaxed">
                    {t("team.hiring_body")}
                  </p>
                  <span className="mt-4 text-sm text-primary underline underline-offset-4">
                    {t("team.hiring_cta")}
                  </span>
                </div>
              </a>
            </Reveal>
          )}
        </div>
      </div>
    </section>
  );
};
